"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingListItem = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const ProgressiveImage_1 = __importDefault(require("../../../common/components/Other/ProgressiveImage"));
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const StylingWrapper = styled_components_1.default.div `
  position: relative;
  cursor: pointer;
`;
const BookingListItemWrapper = styled_components_1.default.div `
  display: flex;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 15px;
  position: relative;
  cursor: pointer;
  .progressive-image {
    height: 120px;
    width: 120px;
    flex-shrink: 0;
    border-radius: 5px;
    @media (max-width: 480px) {
      height: 100px;
      width: 100px;
    }
  }
`;
const ImageContainer = styled_components_1.default.div `
  height: 120px;
  width: 120px;
  flex-shrink: 0;
  border-radius: 5px;
  background: linear-gradient(
    12deg,
    ${props => props.theme.palette.mainAppColor.dark} 5%,
    ${props => props.theme.palette.mainAppColor.light} 25%,
    ${props => props.theme.palette.mainAppColor.main} 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  @media (max-width: 480px) {
    height: 100px;
    width: 100px;
  }
`;
const BookingTexts = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0 10px 10px;
`;
const DateAndTime = styled_components_1.default.div `
  display: flex;
  color: #808080;
  height: 20px;
`;
const BookingTitle = styled_components_1.default.div `
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
`;
const BookingState = styled_components_1.default.div `
  color: #808080;
`;
const BookingTime = styled_components_1.default.div `
  position: absolute;
  right: 16px;

  @media (min-width: 768px) {
    right: 24px;
  }
`;
const BookingListItem = ({ data, fetchNewBookings, currentLocale, timezone }) => {
    let date = null;
    let time = null;
    const history = (0, react_router_dom_1.useHistory)();
    const match = (0, react_router_dom_1.useRouteMatch)();
    const location = (0, react_router_dom_1.useLocation)();
    if (data.isoTime) {
        const timeAndDate = helpers_1.Helpers.getDateFromStringDependingLocale(data.isoTime, currentLocale, timezone);
        // eslint-disable-next-line prefer-destructuring
        date = timeAndDate.date;
        // eslint-disable-next-line prefer-destructuring
        time = timeAndDate.time;
    }
    return (react_1.default.createElement(StylingWrapper, { onClick: () => {
            history.push({
                pathname: `${match.url}/${data.code}`,
                search: location.search,
            });
            setTimeout(() => {
                helpers_1.Helpers.openModal(modalEnums_1.default.BOOKING_DETAILS, {
                    booking: data,
                    fetchNewBookings,
                    redirectOnClose: match.url,
                });
            }, 0);
        } },
        react_1.default.createElement(BookingListItemWrapper, { className: "booking-item", "data-testid": "booking-list-item" },
            data.imageUrl ? (react_1.default.createElement(ProgressiveImage_1.default, { image: data.imageUrl, alt: data.title, imageClass: "progressive-image" })) : (react_1.default.createElement(ImageContainer, { className: "image-container" })),
            react_1.default.createElement(BookingTexts, null,
                react_1.default.createElement(DateAndTime, null,
                    date && (react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(Typography_1.default, { variant: "body2" }, date))),
                    time && (react_1.default.createElement(BookingTime, null,
                        react_1.default.createElement(Typography_1.default, { variant: "body2" }, time)))),
                react_1.default.createElement(BookingTitle, null,
                    react_1.default.createElement(Typography_1.default, { variant: "body1" }, data.title)),
                react_1.default.createElement(BookingState, null,
                    react_1.default.createElement(Typography_1.default, { variant: "body2" }, `${data.code} ${data.formattedState}`))))));
};
exports.BookingListItem = BookingListItem;
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.BookingListItem);
